import { FleetUUIDs } from '../enums';
import { useFleet } from './useFleet';
import { useHasAccess } from './useHasAccess';

export const useAssetManagement = (): boolean => {
  const fleet = useFleet();

  if (fleet.uuid === FleetUUIDs.SacRTBusStopShelter) {
    return true;
  }

  return false;
};

export const useAssetManagementForCustomer = (): boolean => {
  const fleet = useFleet();
  const hasAccess = useHasAccess();

  if (fleet.uuid === FleetUUIDs.SacRTBusStopShelter && !hasAccess) {
    return true;
  }
  return false;
};
